/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Prevent zoom on focus
  document.addEventListener("DOMContentLoaded", function () {
    // For all input fields
    const inputFields = document.querySelectorAll("input, select, textarea");

    inputFields.forEach((input) => {
      input.addEventListener("focus", function () {
        // Prevent zooming by adjusting viewport
        document
          .querySelector('meta[name="viewport"]')
          .setAttribute(
            "content",
            "width=device-width, initial-scale=1, maximum-scale=1"
          );
      });

      input.addEventListener("blur", function () {
        // Reset viewport
        document
          .querySelector('meta[name="viewport"]')
          .setAttribute("content", "width=device-width, initial-scale=1");
      });
    });
  });
  // Add custom code below this line
  document.querySelectorAll(".menu__item").forEach((item) => {
    item.addEventListener("mouseenter", () => {
      document.getElementById("MainContent").classList.add("has-overlay");
    });
    item.addEventListener("mouseleave", () => {
      document.getElementById("MainContent").classList.remove("has-overlay");
    });
  });

  // Grab NodeLists of elements
  const headerLogos = document.querySelectorAll(".logo-container-header");
  const defaultLogos = document.querySelectorAll(".default__logo");
  const scrollLogos = document.querySelectorAll(".scroll__logo img");
  const headerElem = document.querySelector(".theme__header .section-padding");

  function handleScroll() {
    const scrollValue = window.scrollY || window.pageYOffset;
    // console.log("Current scroll position:", scrollValue, "px");

    if (scrollValue >= 1) {
      // console.log("Scrolled >= 10px: show all .scroll__logo, hide .default__logo.");

      // Hide ALL default logo
      defaultLogos.forEach((el) => {
        el.style.visibility = "hidden";
        el.style.display = "none";
      });
      // Show ALL scroll logos
      scrollLogos.forEach((el) => {
        el.style.visibility = "visible";
        el.style.display = "block";
        el.style.opacity = "1";
      });
      headerLogos.forEach((el) => {
        el.style.maxHeight = "35px";
      });
      headerElem?.classList.add("header-padding");
    } else {
      // console.log("Scrolled < 10px: show all .default__logo, hide .scroll__logo.");

      // Revert to default logos visible
      defaultLogos.forEach((el) => {
        el.style.visibility = "visible";
        el.style.display = "block";
      });
      // Hide scroll logos
      scrollLogos.forEach((el) => {
        el.style.visibility = "hidden";
        el.style.display = "none";
        el.style.opacity = "0";
      });
      headerLogos.forEach((el) => {
        el.style.maxHeight = "100px";
      });
      headerElem?.classList.remove("header-padding");
    }
  }

  // Listen for scroll
  window.addEventListener("scroll", handleScroll);

  // Run once on page load (in case user is already scrolled)
  handleScroll();

  class CartBarQuantity {
    constructor() {
      this.quantityInput = document.querySelector("[data-cart-bar-quantity]");
      this.minusButton = document.querySelector(
        "[data-cart-bar-quantity-minus]"
      );
      this.plusButton = document.querySelector("[data-cart-bar-quantity-plus]");
      this.submitButton = document.querySelector("[data-cart-bar-submit]");

      if (this.quantityInput && this.minusButton && this.plusButton) {
        this.init();
      }
    }

    init() {
      // Add click handlers for plus/minus buttons
      this.minusButton.addEventListener("click", () =>
        this.updateQuantity("decrease")
      );
      this.plusButton.addEventListener("click", () =>
        this.updateQuantity("increase")
      );

      // Add input handler for direct quantity changes
      this.quantityInput.addEventListener("change", () =>
        this.validateQuantity()
      );

      // Modify submit button click to include quantity
      if (this.submitButton) {
        this.submitButton.addEventListener("click", (e) =>
          this.handleSubmit(e)
        );
      }
    }

    updateQuantity(action) {
      let currentValue = parseInt(this.quantityInput.value);

      if (action === "increase") {
        currentValue++;
      } else if (action === "decrease" && currentValue > 1) {
        currentValue--;
      }

      this.quantityInput.value = currentValue;
      this.validateQuantity();
    }

    validateQuantity() {
      let value = parseInt(this.quantityInput.value);

      // Ensure minimum of 1
      if (value < 1 || isNaN(value)) {
        value = 1;
      }

      this.quantityInput.value = value;
    }

    handleSubmit(e) {
      // Get the current quantity
      const quantity = parseInt(this.quantityInput.value);

      // Add quantity to form data or cart API call
      if (window.theme && window.theme.cart) {
        // Assuming your theme has a cart API
        const variantId = this.submitButton.dataset.variantId;

        window.theme.cart.addItem(variantId, {
          quantity: quantity,
        });
      }
    }
  }

  // Initialize when DOM is loaded
  document.addEventListener("DOMContentLoaded", () => {
    new CartBarQuantity();

    const bundleDropdown = document.querySelector(".bundle-dropdown");

    if (bundleDropdown) {
      const trigger = bundleDropdown.querySelector(".bundle-select-trigger");
      const optionsList = bundleDropdown.querySelector(".bundle-options-list");
      const selectedOption = bundleDropdown.querySelector(".selected-option");
      const options = bundleDropdown.querySelectorAll(".bundle-option");

      // Toggle dropdown
      trigger?.addEventListener("click", () => {
        const isExpanded = trigger.getAttribute("aria-expanded") === "true";
        trigger.setAttribute("aria-expanded", !isExpanded);
        optionsList.hidden = isExpanded;
      });

      // Close dropdown when clicking outside
      document.addEventListener("click", (event) => {
        if (!bundleDropdown.contains(event.target)) {
          trigger?.setAttribute("aria-expanded", "false");
          optionsList.hidden = true;
        }
      });

      // Handle option selection
      options.forEach((option) => {
        option.addEventListener("click", () => {
          // Update selected option content
          const selectedOptionContent =
            selectedOption.querySelector(".option-content");
          const newOptionContent = option.querySelector(".option-content");
          selectedOptionContent.innerHTML = newOptionContent.innerHTML;

          // Update data attributes
          const dataAttributes = option
            .getAttributeNames()
            .filter((name) => name.startsWith("data-"));

          dataAttributes.forEach((attr) => {
            selectedOption.setAttribute(attr, option.getAttribute(attr));
          });

          // Check for matching variant ID in bundle checkboxes
          const variantId = option.getAttribute("data-variant-id");
          const bundleCheckboxes = document.querySelectorAll(
            ".bundle-section-container .bundle-product-item .bundle-checkbox input"
          );

          // Only handle collapsible elements if option has meta-option class
          if (option.classList.contains("meta-bundle-option")) {
            bundleCheckboxes.forEach((checkbox) => {
              if (checkbox.getAttribute("data-variant-id") === variantId) {
                console.log(
                  "Found matching checkbox for variant ID:",
                  variantId,
                  checkbox
                );
                // Trigger click event on the matching checkbox
                checkbox.click();
              }
            });
          }

          // Update cart bar elements
          updateCartBar(option);

          // Update button text based on meta-bundle-option class
          const buttonText = document.querySelector(
            "#cart-bar .cart-bar__container-right .cart-bar__buttons button .btn__text"
          );
          if (buttonText) {
            if (option.classList.contains("meta-bundle-option")) {
              buttonText.innerText = "ADD RITUAL";
            } else {
              buttonText.innerText = "ADD TO CART";
            }
          }

          // Close dropdown
          trigger.setAttribute("aria-expanded", "false");
          optionsList.hidden = true;

          // Handle scroll behavior
          if (option === options[0]) {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          } else {
            const mainBundleSection =
              document.querySelector(".main-bundle-outer");
            if (mainBundleSection) {
              mainBundleSection.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }
          }
        });
      });

      function updateCartBar(selectedOption) {
        // Update image
        const cartBarImage = document.querySelector(".cart-bar__image img");
        if (cartBarImage) {
          cartBarImage.src = selectedOption.getAttribute("data-product-image");
          cartBarImage.srcset =
            selectedOption.getAttribute("data-product-image");
        }

        // Update title
        const productTitle = document.querySelector(
          ".cart-bar__product__title"
        );
        if (productTitle) {
          productTitle.textContent =
            selectedOption.getAttribute("data-product-title");
        }

        // Reset quantity input to 1
        const quantityInput = document.querySelector(
          ".cart-bar__buttons .quantity__input"
        );
        // console.log(quantityInput);
        if (quantityInput) {
          quantityInput.value = "1";
        }

        // Update variant ID in add to cart form
        const variantInput = document.querySelector(
          '.cart-bar__buttons product-form input[name="id"]'
        );
        if (variantInput) {
          variantInput.value = selectedOption.getAttribute("data-variant-id");
        }

        // Update all product count elements
        const productCountElements =
          document.querySelectorAll(".cart-bar__count");
        if (productCountElements.length > 0) {
          productCountElements.forEach((element) => {
            element.textContent =
              selectedOption.getAttribute("data-product-count");
          });
        }

        // Update all weight elements
        const weightElements = document.querySelectorAll(".cart-bar__weight");
        if (weightElements.length > 0) {
          weightElements.forEach((element) => {
            element.textContent = selectedOption.getAttribute(
              "data-product-weight"
            );
          });
        }
      }
    }
  });


  class CustomFilterClear extends HTMLElement {
    constructor() {
      super();
      this.attachEventListeners();
    }

    attachEventListeners() {
      // Add click event listeners to all filter clear links
      const filterLinks = this.querySelectorAll(
        "a.active__filters__remove, a.active__filters__clear"
      );

      filterLinks.forEach((link) => {
        link.addEventListener("click", (event) => {
          // Let the default link behavior happen (which updates the URL)
          // But also handle our custom deselection logic

          // If it's the "Clear all" link, deselect all filter cells
          if (link.classList.contains("active__filters__clear")) {
            this.deselectAllFilterCells();
            return;
          }

          // Get the filter value from the small tag inside the link
          const smallTag = link.querySelector("small");
          if (!smallTag) return;

          const filterValue = smallTag.textContent.trim();
          this.deselectMatchingFilterCell(filterValue);
        });
      });
    }

    deselectAllFilterCells() {
      const filterCells = document.querySelectorAll(
        ".custom-filter-div .filter-cell"
      );
      filterCells.forEach((cell) => {
        cell.classList.remove("selected");
      });
    }

    deselectMatchingFilterCell(filterValue) {
      const filterCells = document.querySelectorAll(
        ".custom-filter-div .filter-cell"
      );

      filterCells.forEach((cell) => {
        const cellText = cell.textContent.trim();
        if (cellText === filterValue) {
          cell.classList.remove("selected");
        }
      });
    }
  }

  // Register the custom element
  customElements.define("custom-filter-clear", CustomFilterClear);

  const productsGrid = document.querySelector(
    ".collection__products .grid-outer"
  );

  if (productsGrid) {
    // Function to update the product count
    function updateProductCount() {
      const productCountContainer = document.querySelector(
        ".product-count-container"
      );
      const productCountCustom = document.querySelector(
        ".product-count-custom"
      );

      if (productCountContainer && productCountCustom) {
        productCountCustom.innerHTML = productCountContainer.innerHTML;
      }
    }

    // Initial update
    updateProductCount();

    // Create a new MutationObserver instance
    const observer = new MutationObserver(function (mutations) {
      console.log("Collection products grid changed:", mutations);
      updateProductCount();
    });

    // Start observing the target node for configured mutations
    observer.observe(productsGrid, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    console.log("MutationObserver set up for collection products grid");
  } else {
    console.log("Collection products grid element not found");
  }
})();

// Flag to ensure we only initialize once
let initialized = false;
// Flag to track if cancel button event is attached
let cancelButtonInitialized = false;

// Function to initialize the functionality
function initializeCartBarToggle() {
  if (initialized) return; // Prevent multiple initializations
  
  // Find the link element inside jdgm-widget-actions-wrapper
  const actionLink = document.querySelector('.jdgm-widget-actions-wrapper a');
  // Find the cart-bar element
  const cartBar = document.getElementById('cart-bar');
  
  // Add click event listener to the action link (open/close functionality)
  if (actionLink && cartBar) {
    actionLink.addEventListener('click', function(e) {
      e.preventDefault(); // Prevent default link behavior
      
      // Check current state
      if (cartBar.classList.contains('open')) {
        // If currently open, close it
        cartBar.classList.remove('open');
        cartBar.classList.add('closed');
      } else {
        // If currently closed, open it
        cartBar.classList.remove('closed');
        cartBar.classList.add('open');
      }
      
      // After action link is clicked, try to attach event to cancel button
      // Use setTimeout to give the DOM time to update
      setTimeout(attachCancelButtonEvent, 300);
    });
  }
  
  // Initialize cart-bar with open class by default
  if (cartBar) {
    cartBar.classList.add('open');
  }
  
  // Mark as initialized
  initialized = true;
  
  // Remove scroll listener since we don't need it anymore
  window.removeEventListener('scroll', checkScrollPosition);
}

// Function to attach event to cancel button
function attachCancelButtonEvent() {
  // Find the cancel review element that was dynamically created
  const cancelReview = document.querySelector('.jdgm-cancel-rev');
  const cartBar = document.getElementById('cart-bar');
  
  // Only attach event if element exists and we haven't attached it before
  if (cancelReview && cartBar && !cancelButtonInitialized) {
    cancelReview.addEventListener('click', function(e) {
      // Only open if currently closed
      if (cartBar.classList.contains('closed')) {
        cartBar.classList.remove('closed');
        cartBar.classList.add('open');
      }
    });
    
    // Mark as initialized so we don't attach multiple times
    cancelButtonInitialized = true;
    console.log('Cancel button event attached');
  }
}

// Function to check scroll position
function checkScrollPosition() {
  if (window.scrollY >= 100) {
    initializeCartBarToggle();
  }
}

// Add scroll event listener
window.addEventListener('scroll', checkScrollPosition);

// Also check on initial load in case page is already scrolled
document.addEventListener('DOMContentLoaded', checkScrollPosition); 